// extracted by mini-css-extract-plugin
module.exports = {"switch":"Toggle-module--switch--LUUBh","slider":"Toggle-module--slider--KtltR","round":"Toggle-module--round--1XdYZ"};